export const formatUTCDateForLastUpdated = (utcString: string) => {
  const date = new Date(utcString);

  const month = date.toLocaleString('en-US', {
    month: 'short',
    timeZone: 'UTC',
  });
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();

  const hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');
  const isPM = hours >= 12;

  const hour12 = hours % 12 || 12;
  const period = isPM ? 'pm' : 'am';

  return `${month} ${day}, ${year} at ${hour12}:${minutes}${period}`;
};
